import React from 'react';

import { Stack, Grid, Button, FormControlLabel, Checkbox, Typography } from '@metarouter-private/mr-mui';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';
import { useBulkDeployModalContext, BULK_DEPLOY_MODALS } from 'ion-experimental/app/bulk-deploy/BulkDeployModalContext';

import BulkDeploySearchBar from './BulkDeploySearchBar';
import BulkDeployClusterMultiSelect from './BulkDeployClusterMultiSelect';
import IntegrationSelect from './IntegrationSelect';
import RevisionSelect from './RevisionSelect';
import TagsMultiSelect from './TagsMultiSelect';
import GetPipelinesButton from './GetPipelinesButton';

export default function BulkDeployTableTitle() {
  const { isDeploying, selectedPipelineIds, onlyShowSelected, setOnlyShowSelected } = useBulkDeployPageContext();
  const { onOpenModal } = useBulkDeployModalContext();
  const { pipelineTagsMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.pipelineTagsMvp);

  const selectedCount = selectedPipelineIds.size;
  const hasSelection = selectedCount > 0;

  const handleOpenDeployModal = () => {
    onOpenModal(BULK_DEPLOY_MODALS.CONFIRM_BULK_DEPLOY);
  };

  const handleOnlyShowSelectedChange = event => {
    setOnlyShowSelected(event.target.checked);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <BulkDeployClusterMultiSelect disabled={isDeploying} />
        </Grid>

        <Grid item xs={9}>
          <BulkDeploySearchBar disabled={isDeploying} />
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item flexGrow={1}>
          <Grid container gap={1}>
            <Grid item flexGrow={1}>
              <IntegrationSelect disabled={isDeploying} />
            </Grid>

            <Grid item xs={3}>
              <RevisionSelect disabled={isDeploying} />
            </Grid>

            {pipelineTagsMvpEnabled && (
              <Grid item xs={3} width={0}>
                <TagsMultiSelect disabled={isDeploying} />
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item flexShrink={0}>
          <GetPipelinesButton />
        </Grid>

        <Grid item flexShrink={0}>
          <Button
            variant="contained"
            onClick={handleOpenDeployModal}
            disabled={!hasSelection || isDeploying}
            data-test-id="deployPipelinesButton"
          >
            Deploy Pipelines
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <FormControlLabel
            control={
              <Checkbox checked={onlyShowSelected} onChange={handleOnlyShowSelectedChange} disabled={isDeploying} />
            }
            label="Only Show Selected"
          />
        </Grid>

        <Grid item>
          <Typography variant="body2" color="text.secondary">
            {buildItemsSelectMessage(selectedCount)}
          </Typography>
        </Grid>
      </Grid>
    </Stack>
  );
}

function buildItemsSelectMessage(selectedCount) {
  switch (selectedCount) {
    case 0:
      return 'No pipelines selected';
    case 1:
      return '1 pipeline selected';
    default:
      return `${selectedCount} pipelines selected`;
  }
}
